import React, { memo } from 'react';
import { Input } from 'antd';

interface TextBoxProps {
  type?: 'text' | 'password' | 'number';
  value?: string | number;
  onChange?: (value: string | number) => void;
  placeholder?: string;
  defaultValue?: string | number;
  style?: React.CSSProperties;
  disabled?: boolean;
  className?: string;
  readOnly?: boolean;
  prefix?: React.ReactNode;
}

const TextBox: React.FC<TextBoxProps> = ({
  type = 'text',
  value,
  onChange,
  placeholder = 'Enter text',
  disabled = false,
  defaultValue,
  style,
  className,
  readOnly,
  ...rest
}) => {
  return (
    <Input
      type={type}
      value={value}
      onChange={e => onChange && onChange(e.target.value)}
      placeholder={placeholder}
      defaultValue={defaultValue}
      style={style}
      disabled={disabled}
      className={`${readOnly && 'border-none'} focus:outline-none focus:shadow-none ${className}`}
      {...rest}
    />
  );
};

export default memo(TextBox);
